/**
 * KAN-980 / KAN-979: раздел платформы только суперпользователю (is_superuser
 * из /api/v1/auth/me/). Пока пользователь грузится, ничего не рисуется;
 * остальных уводит на дашборд.
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/useCurrentUser';

export function SuperuserGuard({ children }: { children: ReactNode }) {
  const { data: user, isLoading } = useCurrentUser();
  if (isLoading) return null;
  if (user?.is_superuser !== true) return <Navigate to="/" replace />;
  return <>{children}</>;
}
